import {ContainerModule, inject, injectable} from 'inversify';
import {makeObservable} from 'mobx';

import {AppNavigationService} from '@yourcoach/shared/core/system/navigation/app/AppNavigation.service';
import {BaseNavigationService} from '@yourcoach/shared/core/system/navigation/base/BaseNavigation.service';
import {registerBaseNavigation} from '@yourcoach/shared/core/system/navigation/base/registerBaseNavigation';

import {routerPath} from '@src/routes/path';

@injectable()
class NavigationServiceImpl implements AppNavigationService {
  constructor(
    @inject(BaseNavigationService)
    public readonly baseNavigation: BaseNavigationService,
  ) {
    makeObservable(this);
  }

  goToEvent(config: AppNavigationService.GoToEvent) {
    const path = routerPath.event.$buildPath({
      params: {
        eventId: config.id,
      },
    });

    this.baseNavigation.navigate(path);
  }

  goToTodos(config: AppNavigationService.GoToTodos) {
    const path = routerPath.todos.$buildPath({
      searchParams: {
        cs: config.courseId ?? undefined,
        t: config.type,
      },
    });

    this.baseNavigation.navigate(path);
  }
}

export const createNavigationModule = (
  navigation: BaseNavigationService.Navigation,
): ContainerModule[] => {
  const baseNavigationModule = registerBaseNavigation(service => {
    service.setupNavigation(navigation);

    return service;
  });
  const appNavigationModule = new ContainerModule(options => {
    options
      .bind<AppNavigationService>(AppNavigationService)
      .to(NavigationServiceImpl)
      .inSingletonScope();
  });

  return [baseNavigationModule, appNavigationModule];
};
